import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScanSplit } from '@devinforius/i-scan';
import { Observable } from 'rxjs';
import { Scan } from 'src/app/shared/models/iScanAPI/scan';
import { UploadFileParams, UploadScan } from 'src/app/shared/models/iScanAPI/upload-scan';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IScanAPIService {
  public iscanBaseUrl: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iscanBaseUrl = config.apiScanRoot + '/api/v1';
  }

  getIscanData(fileGuid: string, withoutUrl = false): Observable<Scan> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (withoutUrl) {
      return this.http.get<Scan>(`${this.iscanBaseUrl}/files/${fileGuid}/data?withoutUrl=${withoutUrl}`, {
        headers: headers,
      });
    } else {
      return this.http.get<Scan>(`${this.iscanBaseUrl}/files/${fileGuid}/data`, {
        headers: headers,
      });
    }
  }

  upload(event: UploadFileParams): Observable<UploadScan[]> {
    const formData = new FormData();
    event.file.forEach((file, index) => {
      formData.append(`file${index}`, file);
    });
    formData.append('splitMode', event.splitMode);
    formData.append('callback', event.callback);
    return this.http.post<UploadScan[]>(`${this.iscanBaseUrl}/files/upload`, formData);
  }

  getBlob(fileGuid: string, pageGuid: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.iscanBaseUrl}/files/${fileGuid}/pages/${pageGuid}/image`, {
      responseType: 'blob' as 'json',
    });
  }

  downloadSplit(fileGuid: string, splitGuid: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.iscanBaseUrl}/files/${fileGuid}/splits/${splitGuid}/pdf`, {
      responseType: 'blob' as 'json',
    });
  }

  downloadFile(fileGuid: string): Observable<Blob> {
    return this.http.get<Blob>(`${this.iscanBaseUrl}/files/${fileGuid}`, { responseType: 'blob' as 'json' });
  }

  saveSplit(fileGuid: string, split: ScanSplit[]): Observable<Scan> {
    const basicInfosToSend = [];
    split.forEach((split) => {
      basicInfosToSend.push({
        lock: split.lock,
        guid: split.guid,
        pages: split.pages.map((page) => {
          return {
            guid: page.guid,
            rotation: page.rotation,
          };
        }),
      });
    });
    return this.http.put<Scan>(`${this.iscanBaseUrl}/files/${fileGuid}/data`, basicInfosToSend);
  }

  deleteFile(fileGuid: string): Observable<void> {
    return this.http.delete<void>(`${this.iscanBaseUrl}/files/${fileGuid}`);
  }

  getStatus(fileGuid: string): Observable<{ guid: string; status: string }> {
    return this.http.get<{ guid: string; status: string }>(`${this.iscanBaseUrl}/files/${fileGuid}/status`);
  }
}
